import { Component,
    Input,
    TemplateRef
} from '@angular/core';
import { TreeService } from '../services/tree.service';

@Component({
    selector: 'LoaderComponent',
    styles: ['.spinner{ height:16px; width:16px; ' +
    'min-height:16px; min-width:16px; ' +
    'margin: 0px 4px -3px -3px }'
    ],
    template: `<span *ngIf="!loadingTemplate" class="spinner"></span>
    <ng-template [ngTemplateOutlet]="loadingTemplate"></ng-template>`
})

export class LoaderComponent {
    @Input() loadingTemplate: TemplateRef<any>;
}



// WEBPACK FOOTER //
// ./src/common/tree/components/loader.component.ts